export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20young%20crowd%20sitting%20together%20eating%20watermelon%20and%20chatting%20with%20chat%20bubbles%2C%20megaphone%20and%20phone%20icons%20floating%2C%20vibrant%20watermelon%20coral%20red%20and%20fresh%20mint%20green%20color%20palette%20on%20a%20warm%20cream%20background%2C%20playful%20youthful%20entertainment%20energy%2C%20soft%20rounded%20shapes%2C%20high%20detail%20editorial%20illustration&width=1600&height=900&seq=hero-melon-x1&orientation=landscape"
          alt="吃瓜围观与水蜜桃色瓜皮主题插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-900/70 to-primary-950/85"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/50 to-transparent"></div>
      </div>

      <div className="relative mx-auto flex min-h-[620px] w-full max-w-7xl flex-col justify-center px-4 py-28 md:px-6 md:py-32">
        <div className="max-w-3xl animate-pop">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
            </span>
            当前投稿渠道持续收料中
          </span>

          <h1 className="mt-6 text-3xl font-extrabold leading-tight text-background-50 sm:text-4xl md:text-6xl">
            吃瓜投稿入口<span className="text-accent-400">全攻略</span>
            <br className="hidden sm:block" />
            微信·邮箱·链接渠道一站汇总
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            不用满网绕路，这里把当前开放的吃瓜投稿微信、投稿邮箱、在线链接与社群渠道一次性整理清楚。按稿件类型选对最快通道，手把手把瓜料递到编辑手上。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#methods"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-base font-semibold text-background-50 shadow-lg shadow-primary-950/20 transition-all hover:-translate-y-0.5 hover:bg-accent-400"
            >
              查看投稿方式
              <i className="ri-arrow-down-line text-lg" aria-hidden="true"></i>
            </a>
            <a
              href="#flow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-7 py-3.5 text-base font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              投稿流程
              <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div className="mt-14 grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-3">
          {[
            { num: "4 类", label: "微信 / 邮箱 / 链接 / 社群入口" },
            { num: "3 步", label: "选通道 → 备材料 → 提交" },
            { num: "24h", label: "常规稿件审阅时效参考" },
          ].map((it) => (
            <div
              key={it.label}
              className="rounded-2xl border border-background-50/15 bg-background-50/10 px-5 py-4 backdrop-blur"
            >
              <div className="font-heading text-2xl font-bold text-accent-400">{it.num}</div>
              <div className="mt-1 text-sm text-background-100/85">{it.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-b from-transparent to-background-50"></div>
    </section>
  );
}